import axios from 'axios'

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Add JWT token to requests
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect on auth endpoint 401s — those are handled by the store
      const isAuthEndpoint = error.config?.url?.includes('/auth/')
      if (!isAuthEndpoint) {
        localStorage.removeItem('token')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

// API Methods

// Audit Export
export const auditApi = {
  generateExport: async (timeRange) => {
    const response = await apiClient.post('/events/audit/export', { timeRange })
    return response.data
  },

  getExportHistory: async () => {
    // Get all AUDIT_EXPORT_GENERATED events
    const response = await apiClient.get('/events', {
      params: {
        eventType: 'AUDIT_EXPORT_GENERATED',
        limit: 50
      }
    })
    return response.data
  }
}

// Compliance API
export const complianceApi = {
  getScore: async () => {
    const response = await apiClient.get('/compliance/score')
    return response.data
  },

  getChecks: async () => {
    const response = await apiClient.get('/compliance/checks')
    return response.data
  },

  getRecommendations: async () => {
    const response = await apiClient.get('/compliance/recommendations')
    return response.data
  },

  getFrameworkCompliance: async (framework) => {
    const response = await apiClient.get(`/compliance/frameworks/${framework}`)
    return response.data
  }
}

// Departments API (Phase 1)
export const departmentsApi = {
  list: () => apiClient.get('/departments'),
  get: (id) => apiClient.get(`/departments/${id}`),
  create: (data) => apiClient.post('/departments', data),
  update: (id, data) => apiClient.put(`/departments/${id}`, data),
  remove: (id) => apiClient.delete(`/departments/${id}`)
}

// Systems API (Phase 2: department links)
export const systemsApi = {
  linkDepartments: (systemId, departmentIds) =>
    apiClient.post(`/systems/${systemId}/departments`, { departmentIds }),
  unlinkDepartment: (systemId, departmentId) =>
    apiClient.delete(`/systems/${systemId}/departments/${departmentId}`)
}
